<!-- 底部 -->
<template>
  <div class="footer">
    <div class="footer_top">
      <div class="container">
        <div class="site_footer">
          <div class="site_map"></div>
          <div class="site_box">
            <div class="foot_item foot_item1">
              <div class="logo">
                <img src="../../../static/img/fot_logo.png" alt="" />
              </div>
              <!-- <p
                style="
                  font-size: 16px;
                  color: #ada8ba;
                  margin: 0;
                  padding-top: 30px;
                  padding-bottom: 30px;
                  line-height: 30px;
                "
              >
                There are many vari of pass of lorem ipsum availab but the
                majority have suffered in some forms.
              </p> -->
              <!-- <div class="link_left">
                <a href="#" style="margin-left: 0">
                  <i class="iconfont icon-fl-dian"></i>
                </a>
                <a href="#">
                  <i class="iconfont icon-zhijiao-triangle"></i>
                </a>
                <a href="#">
                  <i class="iconfont icon-cuiban"></i>
                </a>
                <a href="#">
                  <i class="iconfont icon-daohangdizhiweizhi"></i>
                </a>
              </div> -->
              <p class="phone">
                <i class="iconfont icon-phone"></i>+86 21 61871158
              </p>
              <p class="adress">
                <i class="iconfont icon-ditu"></i
                >上海浦东新区东三里桥路1018号B座8楼(上海数字产业园)
              </p>
              <router-link :to="{ path: '/contact' }">
                <span class="btn">联系我们</span>
              </router-link>
            </div>
            <div class="foot_item">
              <h1>产品中心</h1>
              <div class="text">
                <div class="left">
                  <p>
                    <router-link :to="{ path: '/productChip' }">
                      <a href="#">数字电视</a>
                    </router-link>
                  </p>
                  <p>
                    <router-link :to="{ path: '/resale' }">
                      <a href="#">智慧零售</a>
                    </router-link>
                  </p>
                  <p>
                    <router-link :to="{ path: '/study' }">
                      <a href="#">智慧学习</a>
                    </router-link>
                  </p>
                  <!-- <p>
                    <a href="#">智慧工地</a>
                  </p>
                  <p>
                    <a href="#">智慧融媒体</a>
                  </p>
                  <p>
                    <a href="#">智慧校园</a>
                  </p> -->
                </div>
                <!-- <div class="right">
                  <p>
                    <a href="#">智慧党建</a>
                  </p>
                  <p>
                    <a href="#">智慧环保</a>
                  </p>
                  <p>
                    <a href="#">智慧社区</a>
                  </p>
                  <p>
                    <a href="#">固边工程</a>
                  </p>
                  <p>
                    <a href="#">智慧门禁</a>
                  </p>
                  <p>
                    <a href="#">智慧广电</a>
                  </p>
                </div> -->
              </div>
            </div>
            <div class="foot_item">
              <h1>合作案例</h1>
              <div class="text">
                <div class="left">
                  <p>
                    <router-link :to="{ path: '/cases' }">
                      <a href="#">合作案例</a>
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
            <div class="foot_item">
              <h1>新闻动态</h1>
              <div class="text">
                <div class="left">
                  <p>
                    <router-link :to="{ path: '/news' }">
                      <a href="#">新闻动态</a>
                    </router-link>
                  </p>
                  <!-- <p>
                    <router-link :to="{ path: '/news', query: { type: 2 } }">
                      <a href="#">行业动态</a>
                    </router-link>
                  </p> -->
                </div>
              </div>
            </div>
            <div class="foot_item">
              <h1>关于我们</h1>
              <div class="text">
                <div class="left">
                  <p>
                    <a @click="goDetail(1)">企业简介</a>
                  </p>
                  <p>
                    <a @click="goDetail(2)">发展历程</a>
                  </p>
                  <p>
                    <a @click="goDetail(3)">荣誉资质</a>
                  </p>
                </div>
              </div>
            </div>
            <div class="foot_item">
              <h1>关注我们</h1>
              <div class="qrcode">
                <img src="../../../static/img/qrcode.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer_bottom">
      <div class="container">
        <div class="last_item">
          <p style="display: flex">
            Copyright 2003-{{ input1 }} 上海高清数字科技产业有限公司
            版权所有&nbsp;
            <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"
              >沪ICP备05009806号-2</a
            >
            <a
              target="_blank"
              style="display: inline-flex"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502006564"
            >
              &nbsp;&nbsp;<img src="../../../static/img/batb.png" alt="" />
              沪公网安备31011502006564号</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input1: "",
    };
  },
  mounted() {
    this.getYear();
  },
  methods: {
    // 获取当前年份
    getYear() {
      let date = new Date();
      this.input1 = date.getFullYear();
      console.log(this.input1);
    },
    goDetail(num) {
      if (num == 0) {
        this.$router.push({ path: "/contact" });
      } else {
        let query = num == 1 ? "0" : num == 2 ? "1" : "2";
        this.$router.push({ path: "/company", query: { id: query } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 大于800px
@media only screen and (min-width: 800px) {
  .footer {
    background-color: #1b1825;
    margin-top: -120px;
    font-family: "Barlow", sans-serif;
    .container {
      max-width: 1595px;
      padding-left: 15px;
      padding-right: 15px;
      margin-right: auto;
      margin-left: auto;
      .site_footer {
        padding: 236px 0 120px;
        position: relative;
        z-index: 1;
      }
      .site_map {
        background-image: url("../../../static/img/site-footer-mape.png");
        position: absolute;
        left: 0;
        right: 0;
        bottom: -42px;
        height: 566px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        opacity: 0.04;
        z-index: -1;
      }
      .site_box {
        display: flex;
        padding: 0 30px;
        padding-left: 40px;
      }

      .foot_item {
        width: calc(100% / 8);
        // width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
        .logo {
          width: 300px;
        }
        p {
          font-size: 16px;
          color: #ada8ba;
        }
        h1 {
          font-size: 20px;
          color: #fff;
          font-weight: 800;
          line-height: 30px;
          margin-bottom: 30px;
        }
        .qrcode {
          width: 110px;
          height: 110px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .foot_item1 {
        width: calc((100% / 3) + 100px);
        margin-right: 180px;
      }
      .foot_item2 {
        padding-left: 50px;
      }
      .logo {
        // width: 175px;
        // height: 52px;
        margin-left: -30px;
        transform: scale(0.8);
        img {
          width: 100%;
          height: 100%;
        }
      }
      .iconfont {
        color: #1789fb;
        font-size: 20px;
        margin-right: 10px;
      }
      .phone {
        height: 28px;
        font-size: 20px;
        // font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 28px;
        margin: 10px 0;
      }
      .adress {
        height: 41px;
        font-size: 14px;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
        line-height: 30px;
        margin: 10px 0;
      }
      .btn {
        display: block;
        padding: 12px 40px;
        width: 160px;
        background: #1789fb;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        margin-top: 40px;
      }
    }
    .footer_bottom {
      max-width: 1595px;
      width: 100%;
      margin: 0 auto;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      .last_item {
        display: flex;
        justify-content: center;
        padding: 35px 15px;
      }
    }
  }
  .text {
    display: flex;
    // justify-content: space-between;
    .left {
      margin-right: 40px;
      p {
        color: #7b7981;
        font-size: 18px;
        line-height: 34px;
        font-weight: 500;
      }
    }
    div p a {
      position: relative;
      display: inline-block;
      font-size: 16px;
      font-weight: 500;
      color: #ada8ba;
      transition: all 500ms ease;
    }
    div p a::after {
      content: "";
      position: absolute;
      top: 90%;
      left: 0;
      width: 100%;
      height: 1px;
      transform: scale(0, 1);
      transform-origin: left center;
      background-color: currentColor;
      transition: transform 500ms ease;
    }
    div p:hover > a::after {
      transform: scale(1, 1);
      transform-origin: right center;
    }
    div p a:hover {
      color: #fff;
    }

    .right {
      p {
        color: #7b7981;
        font-size: 18px;
        line-height: 34px;
        font-weight: 500;
      }
    }
  }
  .site_phone {
    display: flex;
    align-items: center;
    .iconfont {
      font-size: 13px;
      color: #42d9be;
    }
    p {
      margin-left: 10px !important;
      font-size: 16px;
      font-weight: 600;
      margin: 0;
      line-height: 30px;
      color: #fff;
      transition: all 500ms ease;
    }
  }
  .site_phone p:hover {
    color: #42d9be !important;
  }
  /deep/.el-input {
    .el-input__inner {
      font-size: 14px;
      height: 50px !important;
      line-height: 50px !important;
    }
    .el-input-group__append {
      border: none;
      color: #fff;
      background: #1989fb;
    }
  }
}
// 小于800px
@media only screen and (max-width: 800px) {
  .footer {
    background-color: #1b1825;
    margin-top: -7.5rem;
    font-family: "Barlow", sans-serif;
    .container {
      max-width: 100%;
      padding-left: 0.9375rem;
      padding-right: 0.9375rem;
      margin-right: auto;
      margin-left: auto;
      .site_footer {
        padding: 14.75rem 0 7.5rem;
        position: relative;
        z-index: 1;
      }
      .site_map {
        background-image: url("../../../static/img/site-footer-mape.png");
        position: absolute;
        left: 0;
        right: 0;
        bottom: -2.625rem;
        height: 35.375rem;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        opacity: 0.04;
        z-index: -1;
      }
      .site_box {
        // display: flex;
      }

      .foot_item {
        // width: calc(100% / 6);
        padding: 0 0.9375rem;
        box-sizing: border-box;
        p {
          font-size: 1rem;
          color: #ada8ba;
        }
        h1 {
          font-size: 1.25rem;
          color: #fff;
          font-weight: 800;
          line-height: 1.875rem;
          margin-bottom: 1.875rem;
        }
        .qrcode {
          width: 6.875rem;
          height: 6.875rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .foot_item1 {
        // width: 25%;
      }
      .foot_item2 {
        // padding-left: 50px;
      }
      .logo {
        // width: 175px;
        // height: 52px;
        margin-left: -1.875rem;
        transform: scale(0.8);
        img {
          width: 100%;
          height: 100%;
        }
      }
      .iconfont {
        color: #1789fb;
        font-size: 1.25rem;
        margin-right: 0.625rem;
      }
      .phone {
        height: 1.75rem;
        font-size: 1.25rem;
        // font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 1.75rem;
        margin: 0.625rem 0;
      }
      .adress {
        height: 2.5625rem;
        font-size: 0.875rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
        line-height: 1.875rem;
        margin: 0.625rem 0;
      }
      .btn {
        display: block;
        padding: 0.75rem 2.5rem;
        width: 10rem;
        background: #1789fb;
        color: #fff;
        text-align: center;
        border-radius: 0.375rem;
        margin-top: 2.5rem;
      }
    }
    .footer_bottom {
      max-width: 99.6875rem;
      width: 100%;
      margin: 0 auto;
      border-top-left-radius: 0.5rem;
      border-top-right-radius: 0.5rem;
      .last_item {
        display: flex;
        justify-content: center;
        padding: 2.1875rem 0.9375rem;
      }
    }
  }
  .text {
    display: flex;
    // justify-content: space-between;
    .left {
      margin-right: 2.5rem;
      p {
        color: #7b7981;
        font-size: 1.125rem;
        line-height: 2.125rem;
        font-weight: 500;
      }
    }
    div p a {
      position: relative;
      display: inline-block;
      font-size: 1rem;
      font-weight: 500;
      color: #ada8ba;
      transition: all 500ms ease;
    }
    div p a::after {
      content: "";
      position: absolute;
      top: 90%;
      left: 0;
      width: 100%;
      height: 0.0625rem;
      transform: scale(0, 1);
      transform-origin: left center;
      background-color: currentColor;
      transition: transform 500ms ease;
    }
    div p:hover > a::after {
      transform: scale(1, 1);
      transform-origin: right center;
    }
    div p a:hover {
      color: #fff;
    }

    .right {
      p {
        color: #7b7981;
        font-size: 1.125rem;
        line-height: 2.125rem;
        font-weight: 500;
      }
    }
  }
  .site_phone {
    display: flex;
    align-items: center;
    .iconfont {
      font-size: 0.8125rem;
      color: #42d9be;
    }
    p {
      margin-left: 0.625rem !important;
      font-size: 1rem;
      font-weight: 600;
      margin: 0;
      line-height: 1.875rem;
      color: #fff;
      transition: all 500ms ease;
    }
  }
  .site_phone p:hover {
    color: #42d9be !important;
  }
  /deep/.el-input {
    .el-input__inner {
      font-size: 0.875rem;
      height: 3.125rem !important;
      line-height: 3.125rem !important;
    }
    .el-input-group__append {
      border: none;
      color: #fff;
      background: #1989fb;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/comcomponents/Footer.vue